var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExternalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "svg-fill-color svg-stroke-color",
    d: "M1.33 1a.364.364 0 0 0-.33.364v15.272c0 .201.163.364.364.364h15.272c.201 0 .364-.163.364-.364V9a.364.364 0 1 0-.727 0v7.273H1.727V1.728H9A.364.364 0 1 0 9 1H1.33zm10.545 0a.364.364 0 1 0 .034.728h3.852L7.653 9.835a.364.364 0 1 0 .512.512l8.108-8.108v3.852a.364.364 0 1 0 .727 0V1.364c0-.2-.163-.364-.364-.364h-4.761z",
    fillRule: "nonzero",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/external-link.4bc01682221eb57736d49e055195b00f.svg";
export { ForwardRef as ReactComponent };